var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "reporting-call-logs-header" }, [
      _c("h2", {
        directives: [
          {
            name: "t",
            rawName: "v-t",
            value: "HEADER_EXPORT_BIDS",
            expression: "'HEADER_EXPORT_BIDS'"
          }
        ],
        staticClass: "reporting-call-logs-header__title"
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "r-form display-flex flex--wrap p-b-30" },
      [
        _c("SearchableDropdown", {
          staticClass: "rtb-export-timezone m-r-15 m-b-15",
          attrs: {
            rules: "required",
            config: _vm.timeZoneOptions,
            clearable: false
          },
          model: {
            value: _vm.timeZoneId,
            callback: function($$v) {
              _vm.timeZoneId = $$v
            },
            expression: "timeZoneId"
          }
        }),
        _vm._v(" "),
        _c("DateRangePickerSingle", {
          attrs: {
            "date-button-class": "btn daterangepicker-btn--form m-r-15 m-b-15",
            "selected-date": _vm.selectedDate,
            options: _vm.dateSelectConfig,
            "time-zone-id": _vm.translatedTimeZoneId
          },
          on: { onDateChange: _vm.onDateChange }
        }),
        _vm._v(" "),
        _c(
          "PrimaryButton",
          {
            staticClass: "p-l-15 m-b-15",
            class: _vm.isExporting ? "p-r-35" : "p-r-15",
            attrs: { "show-loader-on-form": _vm.isExporting, type: "button" },
            on: { click: _vm.onExportRtbLog }
          },
          [
            _c("i", {
              staticClass: "fa fa-download",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v("\n      " + _vm._s(_vm.$t("BUTTON_EXPORT_CSV")) + "\n    ")
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }